import React, { Component, useEffect, useState } from "react";
import ComponentTopupHistoryMobile from "./ComponentTopupHistoryMobile";
import ComponentTopupHistoryWeb from "./ComponentTopupHistoryWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentTopupHistory = () => {
  const gaEventTracker = useAnalyticsEventTracker("TopupHistory");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Top Up History",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentTopupHistoryWeb></ComponentTopupHistoryWeb>
      </BrowserView>
      <MobileView>
        <ComponentTopupHistoryMobile></ComponentTopupHistoryMobile>
      </MobileView>
    </>
  );
};

export default ComponentTopupHistory;
